module.exports = __webpack_public_path__ + "img/rep-michael.85b4f76f.png";